import { Controller } from "@hotwired/stimulus";
import { dsConfirm } from "../../utils/ds_confirm";

// Connects to data-controller="expense-delete"
export default class extends Controller {
  static targets = ["deleteButton", "confirmModal"];

  connect() {
    console.log("Expense delete controller connected");
  }

  async confirmDelete(event) {
    event.preventDefault();

    const button = event.currentTarget;
    const url = button.getAttribute("data-url");
    const expenseName = button.getAttribute("data-expense-name");

    if (
      await dsConfirm(
        `Êtes-vous sûr de vouloir supprimer la dépense "${expenseName}" ? Cette action est irréversible.`,
        { tone: "danger" },
      )
    ) {
      this.performDelete(url);
    }
  }

  performDelete(url) {
    // Disable button and show loading state
    this.deleteButtonTarget.disabled = true;
    this.deleteButtonTarget.innerHTML =
      '<svg class="mr-3 -ml-1 size-5 animate-spin text-cta" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>';

    fetch(url, {
      method: "DELETE",
      headers: {
        Accept: "text/vnd.turbo-stream.html",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
          .content,
      },
    })
      .then((response) => {
        if (response.ok) {
          return response.text();
        } else {
          throw new Error("Network response was not ok");
        }
      })
      .then((html) => {
        // Render the turbo stream response
        Turbo.renderStreamMessage(html);
      })
      .catch((error) => {
        console.error("Error:", error);
        // Re-enable button and show error
        this.deleteButtonTarget.disabled = false;
        this.deleteButtonTarget.innerHTML =
          '<i class="fas fa-trash"></i> Supprimer';
        alert(
          "Une erreur est survenue lors de la suppression. Veuillez réessayer.",
        );
      });
  }
}
